import {
    Box,
    Button,
    chakra,
    Grid,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text
} from "@chakra-ui/react";
import {DimensionsGridHeaderRow, GridItemsSection} from "./index";
import {dimensionsKeys} from "../../../../utils";
import {useTranslation} from "react-i18next";
import {useForm} from "react-hook-form";
import {getEmptyRow} from "./GridItemsSection";

function DimensionItemModal({ modalData, isOpen, onClose, onSubmit, scope }) {
  const { t } = useTranslation("translation");
  const { organizationStructure, dimensionItems, fieldArrayName, editData } = modalData;

  const {
    register,
    handleSubmit,
    formState: { errors },
    resetField,
    control,
    watch
  } = useForm({
    defaultValues: {
      [modalData.fieldArrayName]: [editData ? editData : getEmptyRow(organizationStructure, dimensionItems, scope)]
    }
  });

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent
        borderRadius="lg"
        w="fit-content"
        maxW="calc(100vw - 32px)"
        minW={{ base: "auto", md: "640px" }}
      >
        <chakra.form onSubmit={handleSubmit(onSubmit)}>
          <ModalHeader fontSize="18px" fontWeight="700" color="darkTeal">
            {t(`organizationQuestionnaire.${editData ? "editItemModalHeader" : "addItemsModalHeader"}`, { type: fieldArrayName })}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Box borderWidth="1px" borderRadius="md" overflow="hidden" bg="white">
              <Grid
                templateColumns={`repeat(${(dimensionsKeys.filter(dimKey =>
                  modalData.organizationStructure.dimensions[dimKey] !== null).length + 3) * 2 + (editData ? 0 : 1)}, auto)`}
                minWidth="700"
                maxHeight="400"
                overflow="auto"
                sx={{
                  "&::-webkit-scrollbar": { width: "6px" },
                  "&::-webkit-scrollbar-thumb": { bg: "transparent", borderRadius: "full" },
                  "&:hover::-webkit-scrollbar-thumb": { bg: "gray.300" },
                  scrollbarWidth: "thin",
                  scrollbarColor: "transparent transparent",
                  "&:hover": { scrollbarColor: "var(--chakra-colors-gray-300) transparent" },
                }}
              >
                <DimensionsGridHeaderRow
                  organizationStructure={modalData.organizationStructure}
                  scope={modalData.scope}
                  consumptionTypesAttr={modalData.consumptionTypesAttr}
                  permanentColumns={editData ?
                    [
                      t("organizationQuestionnaire.dimensionsGrid.category"),
                      t("organizationQuestionnaire.dimensionsGrid.value"),
                      t("organizationQuestionnaire.dimensionsGrid.measure")
                    ] :
                    [
                      t("organizationQuestionnaire.dimensionsGrid.category"),
                      t("organizationQuestionnaire.dimensionsGrid.value"),
                      t("organizationQuestionnaire.dimensionsGrid.measure"),
                      ""
                    ]
                  }
                />
                <GridItemsSection
                  modalData={modalData}
                  formData={{
                    control,
                    watch,
                    register,
                    errors,
                    resetField
                  }}
                />
              </Grid>
            </Box>
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onClose} borderRadius="full">
              {t("buttons.close")}
            </Button>
            <Button bg="lime" color="pureBlack" borderRadius="full" _hover={{ bg: "limeShade.300" }} type="submit">
              {t("buttons.save")}
            </Button>
          </ModalFooter>
        </chakra.form>
      </ModalContent>
    </Modal>
  );
}

export default DimensionItemModal;